import Vue from 'vue';
import VueRouter from 'vue-router';
import { warn } from '@tencent/tks-utils/log';
import { TksRouter } from '@/components/TksRouter';
import { BASIC_MAP, DYNAMIC_ROUTES } from './config/routerMap';
import MapAccount from '@/libs/MapAccount';
import store from './store';

Vue.use(VueRouter);

const tksRouter = new TksRouter({
  routerOptions: {
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
  },
  basicRoutes: BASIC_MAP,
  dynamicRoutes: DYNAMIC_ROUTES,
  /**
   * 鉴权逻辑仅初始化一次
   * @param {Function} next
   */
  async fetchState(next) {
    const { userInfo, roles } = await MapAccount
      .getAuthorization()
      .catch((err) => {
        // 没有登录/没有注册
        warn(err, err.message);
        MapAccount.login();
        return Promise.reject(new Error(err.message));
      });

    store.dispatch('setUserInfo', userInfo);
    store.dispatch('setUserRole', roles);

    // console.log('router页面', userInfo, roles)
    // 已经登录
    if (!roles.length) {
      warn('权限为空！');
      next({ path: '/403?iframe=1' });
      return;
    }

    // 验证成功
    return { roles };
  },
  onRouterAuthed(routers) {
    store.commit('SET_ROUTERS', routers);
  },
});

export default tksRouter.routerInstance;
